var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48",
      width: 24,
      height: 24
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1f1f1f;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,24c-2.2,0-4-0.7-5.4-2.1c-1.4-1.4-2.1-3.2-2.1-5.4s0.7-4,2.1-5.4C20,9.7,21.8,9,24,9s4,0.7,5.4,2.1 c1.4,1.4,2.1,3.2,2.1,5.4s-0.7,4-2.1,5.4C28,23.2,26.2,24,24,24z M8,40v-4.7C8,34,8.3,32.9,8.9,32c0.6-0.9,1.4-1.6,2.4-2 c2.2-1,4.4-1.8,6.4-2.2S21.9,27,24,27s4.1,0.3,6.1,0.8s4.2,1.3,6.4,2.2c1,0.5,1.9,1.1,2.5,2c0.6,0.9,1,2,1,3.2V40H8z M11,37h26v-1.7 c0-0.5-0.2-1-0.5-1.5c-0.3-0.5-0.7-0.8-1.2-1.1c-2.1-1-4.1-1.7-5.9-2.1C27.7,30.2,25.9,30,24,30s-3.8,0.2-5.5,0.6 c-1.8,0.4-3.8,1.1-5.9,2.1c-0.5,0.2-0.9,0.6-1.1,1.1c-0.3,0.5-0.5,1-0.5,1.5V37z M24,21c1.3,0,2.4-0.4,3.2-1.3 c0.8-0.9,1.3-1.9,1.3-3.2s-0.4-2.4-1.3-3.2c-0.9-0.9-1.9-1.3-3.2-1.3s-2.4,0.4-3.2,1.3c-0.8,0.9-1.3,1.9-1.3,3.2s0.4,2.4,1.3,3.2 C21.6,20.5,22.7,21,24,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7f6b6a5bb45f450214fa3406e4eecc04.svg";
export { ForwardRef as ReactComponent };